<div class="sec-title">
  <h1>Soumissions</h1>
</div>
<ul class="list-group">
  <li class="list-group-item list-group-header">
    <div class="card">
      <div class="row">
        <div class="col-lg-8 col-md-12">
        </div>
        <div class="col-lg-1 col-md-4 mt-4">
          <a class="btn btn-action btn-filter" [ngClass]="{'selected_filter': filter=='all'}" (click)="changeFilter('all')" role="button"> Toutes</a>
        </div>
        <div class="col-lg-3 col-md-12 align-text-bottom header-action-btn">
          <form [formGroup]="searchSubmissionForm" (ngSubmit)="onSubmit(searchSubmissionForm.value)" novalidate>
            <div class="form-group input-group mb-3">
              <label for="search_submission" class="visually-hidden">Recherche</label>
              <input type="text" class="form-control" name="search_submission" id="search_submission" formControlName="search_submission" placeholder="Recherche...">
              <div class="input-group-append">
                <button type="submit" class="input-group-text right-action-btn">
                  <i title="Recherche" class="bi bi-search"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-lg-11 col-md-10">
            <div class="row">
              <div class="col-lg-6 col-md-6">Adresse</div>
              <div class="col-lg-4 col-md-4">Client</div>
              <div class="col-lg-2 col-md-2">Soumission</div>
            </div>
          </div>
          <div class="col-md-1 d-flex justify-content-end action-icons">
            <div>Modifier</div>
          </div>
      </div>
      </div>
    </div>
  </li>
  <li class="list-group-item" *ngIf="total === 0 && isSearch == true">
    <div class="card">
      <div class="card-body">
        <div class="row mt-3 ms-3 mb-3 strong">
              {{no_results_message}}
        </div>
      </div>
    </div>
  </li>
  <li *ngIf="diplay_loading != '' && isSearch == false; else Results" class="list-group-item">
    <div class="card">
      <div class="card-body">  
        <div class="mt-3 ms-3 mb-3 strong">
          {{ diplay_loading }} 
          <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
          <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
          <span class="spinner-grow spinner-grow-sm ms-2" style="width: 0.5rem; height: 0.5rem;" role="status" aria-hidden="true"></span>
        </div>
      </div>
    </div>
  </li>
  <ng-template #Results>
    <li class="list-group-item" [ngClass]="{'submisison_refused' : submission.is_refused }" *ngFor="let submission of submissionsList | paginate: { itemsPerPage: limits, currentPage: p+1, totalItems: total}; let i = index">
      <div class="card" >
        <div class="card-body">
          <div class="row">
            <div class="col-md-11">
              <div class="row">
                <div class="col-md-6">
                  <div class="card-subtitle mb-2 txt-strong">
                    <address>
                      {{submission.address}}, {{submission.city}}, 
                      {{submission.province}} {{submission.address2}} 
                      {{submission.country}}
                    </address>
                  </div>
                </div>
                <div class="col-md-4">
                  <ng-container>
                    <ng-container>
                      <p class="card-text">
                        <a routerLink="/client/{{submission.client_id}}/editer"><i class="bi bi-link"></i>{{submission.client_first_name}} {{submission.client_last_name}}</a>
                      </p>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="col-md-2">
                  <p class="card-title card-title-main">#{{submission.submission_no}}</p>
                </div>
              </div>
            </div>
            <div class="col-md-1 d-flex justify-content-end action-icons">
              <a routerLink="/soumission/{{submission.submission_id}}/editer" class="card-link">
                <button type="button" class="btn btn-outline-secondary">
                  <i class="bi bi-pencil-square" title="Modifier la soumission"></i>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ng-template>
  </ul>
  <pagination-controls (pageChange)="pageChangeEvent($event)"></pagination-controls>
